import { render, staticRenderFns } from "./EditCommunicationTemplate.vue?vue&type=template&id=37c3ea9f&"
import script from "./EditCommunicationTemplate.vue?vue&type=script&lang=js&"
export * from "./EditCommunicationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports